import { Box, Button, Flex, Icon } from '@oplog/express';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBox } from '../../../molecules/TouchScreen';
import { ScanPackageModals } from './ScanPackageColumn';

interface IStatusModal {
  setIsOpen: (name: ScanPackageModals, status?: boolean) => void;
  message: string;
}

const StatusModal: FC<IStatusModal> = ({ setIsOpen, message }) => {
  const { t } = useTranslation();

  return (
    <ModalBox
      onClose={() => null}
      isOpen={true}
      width={640}
      headerText={message}
      contentBoxProps={{
        py: '60',
        px: '30',
        color: 'palette.purple_darker',
        border: 'sm',
        borderColor: 'transparent',
        borderRadius: 'md',
      }}
      overlayProps={{
        backgroundColor: 'palette.black',
        opacity: 0.6,
      }}
      icon={
        <Flex
          width={120}
          height={120}
          borderRadius="full"
          bg="palette.softBlue"
          alignItems="center"
          justifyContent="center"
        >
          <Icon name="far fa-engine-warning" fontSize={52} color="palette.white" />
        </Flex>
      }
    >
      <Flex alignItems="center" justifyContent="center" flexDirection="column">
        <Button
          onClick={() => setIsOpen(ScanPackageModals.Status, false)}
          variant="alternative"
          width={1 / 2}
          fontWeight={700}
        >
          {t('Modal.Success.Okay')}
        </Button>
        <Box mt={22} fontSize={16} color="palette.blue_lighter" fontWeight={500}>
          {t('TouchScreen.SlamStation.Modals.ScanNextToContinue')}
        </Box>
      </Flex>
    </ModalBox>
  );
};

export default StatusModal;
